<template>
  <section class="post-aside">
    <PostListRelated :related-posts="relatedPosts" />

    <PostListPopLat :popular-posts="popularPosts" :latest-posts="latestPosts" />

    <PostListMailing />
  </section>
</template>

<script>
import PostService from '@/services/postService';
import _sampleSize from 'lodash.samplesize';

import PostListRelated from '@/components/posts/PostListRelated.vue';
import PostListPopLat from '@/components/posts/PostListPopLat.vue';
import PostListMailing from '@/components/posts/PostListMailing.vue';

export default {
  name: 'SectionPostLists',
  components: {
    PostListRelated,
    PostListPopLat,
    PostListMailing,
  },
  data() {
    return {
      posts: [],
      popularPosts: [],
    };
  },
  computed: {
    relatedPosts() {
      // BRI story category = People & Society - catID = 11
      const relatedPosts = this.posts.filter(post => post.categories.some(cat => cat.id === 11));

      return _sampleSize(relatedPosts, 3);
    },
    latestPosts() {
      return this.posts.filter((post, i) => i < 4);
    },
  },
  async mounted() {
    // fetch posts from API endpoint
    const { data } = await PostService.getPosts();
    this.posts = data;

    // hardcode popular posts
    this.popularPosts = [
      data.find(post => post.slug === 'chinese-muslims-in-indonesia'),
      data.find(post => post.slug === 'asian-representation-in-movies-have-things-changed-since-1997'),
      data.find(post => post.slug === 'china-can-save-the-earth-heres-why'),
      data.find(post => post.slug === 'sex-in-asia-how-sustainable-are-condoms'),
    ];
  },
};
</script>


<style lang="stylus" scoped>
.post-aside {
  border-top: 1px solid #e0e0e0;
  background-color: #F8F4EE;
}
</style>
